export const NOTIFICATION_REQUEST = 'NOTIFICATION_REQUEST'
export const NOTIFICATION_ADD_TOKEN_WEB_REQUEST = 'NOTIFICATION_ADD_TOKEN_WEB_REQUEST';
export const NOTIFICATION_ADD_TOKEN_WEB_FAILED = 'NOTIFICATION_ADD_TOKEN_WEB_FAILED';
export const NOTIFICATION_ADD_TOKEN_WEB_SUCCESS = 'NOTIFICATION_ADD_TOKEN_WEB_SUCCESS';